import storeManager from '../StoreManager';
import constants from '../../qti/Constants';

const questionSelectionReader = {
    selectionType: constants.selectionType,
    getSelectionValueForQuestion(contentRevisionId) {
        const qSelState = storeManager.getState().questionSelection;
        return qSelState[contentRevisionId] || this.selectionType.UNDECIDED;
    },
    getSelectionValuesFromState(selectionValue) {
        const qSelState = storeManager.getState().questionSelection;
        return Object.entries(qSelState).filter(pair => pair[1] === selectionValue).map(pair => parseInt(pair[0], 10));
    },
    getQuestionsWithSelectionValueInSection(selectionValue, section) {
        const sectionQuestions = section.questions.map(question => question.contentRevisionId);
        return this.getSelectionValuesFromState(selectionValue)
            .filter(revisionId => sectionQuestions.includes(revisionId));
    },
    getAllSelectedQuestionsInTest() {
        return this.getSelectionValuesFromState(this.selectionType.YES);
    },
    getSelectedQuestions(section) {
        return this.getQuestionsWithSelectionValueInSection(this.selectionType.YES, section);
    },
    getNotSelectedQuestions(section) {
        return this.getQuestionsWithSelectionValueInSection(this.selectionType.NO, section);
    },
    getUndecidedQuestions(section) {
        const allQuestions = section.questions.map(question => question.contentRevisionId);
        const selectedQuestions = this.getSelectedQuestions(section);
        const notSelectedQuestions = this.getNotSelectedQuestions(section);

        return allQuestions.filter(revisionId => !selectedQuestions.includes(revisionId) && !notSelectedQuestions.includes(revisionId));
    },
};

export default questionSelectionReader;
